export default __webpack_public_path__ + "static/media/TF.d800af87.png";